module.exports = __webpack_public_path__ + "img/user.0113185c.svg";